import { ADMIN_TYPES } from "../constants/adminTypes";

// Define the structure of your state
interface AdminState {
  tutorialStatus?: any;
  currentSubscription?: any; // Specify a more specific type if possible
  analytics?: any; // Specify a more specific type if possible
}

// Define the type for your action
interface AdminAction {
  type: string;
  payload: any; // Consider using a more specific type based on your payload structure
}

// Initial state with type
const initialState: AdminState = {};

// Reducer function with types
const adminReducer = (
  state: AdminState = initialState,
  action: AdminAction
): AdminState => {
  switch (action.type) {
    // -------------- TUTORIAL STATUS --------------
    case ADMIN_TYPES.UPDATE_TUTORIAL_STATUS:
      return {
        ...state,
        tutorialStatus: action?.payload,
      };
    case ADMIN_TYPES.GET_ADMIN_SUBSCRIPTION:
      return {
        ...state,
        currentSubscription: action.payload,
      };
    case ADMIN_TYPES.GET_ADMIN_ANALYTICS:
      return {
        ...state,
        analytics: action.payload,
      };
    default:
      return state;
  }
};

export default adminReducer;
